import { render } from "./HomeMain.vue?vue&type=template&id=648b1ba4"
import script from "./HomeMain.vue?vue&type=script&lang=js"
export * from "./HomeMain.vue?vue&type=script&lang=js"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__